export type RadioItemType = { id: string; name: string; value: string };

export type CheckboxType = {
  label: string;
  value: string;
  checkboxLabel: string;
};

export enum SentenceType {
  OV = 'OV',
  SV = 'SV',
  SVO = 'SVO',
  VO = 'VO',
}

export enum SubjectType {
  NOMEN = 'noun',
  PRONOMEN = 'pronoun',
}

export const SATZE_RADIO: RadioItemType[] = [
  { id: '1', name: 'Objekt-Verb', value: 'OV' },
  { id: '4', name: 'Verb-Objekt', value: 'VO' },
  { id: '2', name: 'Subjekt-Verb', value: 'SV' },
  { id: '3', name: 'Subjekt-Verb-Objekt/Adverbiale', value: 'SVO' },
];

export const SATZE_SUBJECT_RADIO: RadioItemType[] = [
  { id: '1-nomen', name: 'Nomen', value: 'noun' },
  { id: '2-pronomen', name: 'Pronomen', value: 'pronoun' },
];

const OV_CHECK_BOX: CheckboxType[] = [
  {
    label: 'Standard',
    value: 'standard',
    checkboxLabel: 'z.B. Muffins backen',
  },
  {
    label: 'Partikelverb',
    value: 'particleVerb',
    checkboxLabel: 'z.B. Geld abheben',
  },
];

const SVO_COMMON_CHECK_BOX: CheckboxType[] = [
  {
    label: 'Standard',
    value: 'standard',
    checkboxLabel: 'z.B. Die Frau backt Muffins',
  },
  {
    label: '2 Personen',
    value: 'secondPerson',
    checkboxLabel: 'z.B. Der Mann umarmt die Frau',
  },
  {
    label: 'Partikelverb',
    value: 'particleVerb',
    checkboxLabel: 'z.B. Die Köchin rührt die Soße um',
  },
  {
    label: 'Reflexives Verb',
    value: 'reflexiveVerb',
    checkboxLabel: 'z.B. Der Junge kämmt sich die Haare',
  },
  {
    label: 'Präposition',
    value: 'preposition',
    checkboxLabel: 'z.B. Das Mädchen schwimmt im See',
  },
  {
    label: 'Objekt mit Artikel',
    value: 'objectWithArticle',
    checkboxLabel: 'z.B. Der Pilot fliegt das Flugzeug',
  },
  {
    label: 'Partikelverb + 2 Personen',
    value: 'particleVerbAndSecondPerson',
    checkboxLabel: 'z.B. Der Mann liest dem Jungen vor',
  },
  {
    label: 'Partikelverb + Reflexives Verb',
    value: 'particleVerbAndReflexiveVerb',
    checkboxLabel: 'z.B. Der Junge schneidet sich die Haare ab',
  },
];

const SV_COMMON_CHECK_BOX: CheckboxType[] = [
  {
    label: 'Standard',
    value: 'standard',
    checkboxLabel: 'z.B. Die Katze frisst',
  },
  {
    label: 'Partikelverb',
    value: 'particleVerb',
    checkboxLabel: 'z.B. Das Mädchen schläft ein',
  },
  {
    label: 'Reflexives Verb',
    value: 'reflexiveVerb',
    checkboxLabel: 'z.B. Der Junge kämmt sich',
  },
  {
    label: 'Partikelverb + Reflexives Verb',
    value: 'particleVerbAndReflexiveVerb',
    checkboxLabel: 'z.B. Der Mann schnallt sich an',
  },
];

const VO_CHECK_BOX: CheckboxType[] = [
  {
    label: 'Standard',
    value: 'standard',
    checkboxLabel: 'z.B. fährt Auto',
  },
  {
    label: 'Objekt mit Artikel',
    value: 'objectWithArticle',
    checkboxLabel: 'z.B. isst einen Apfel',
  },
];

export const BASIC_NOMEN_CHECK_BOX: Record<SentenceType, CheckboxType[]> = {
  OV: OV_CHECK_BOX,
  SV: [
    ...SV_COMMON_CHECK_BOX,
    {
      label: 'Passiv',
      value: 'passive',
      checkboxLabel: 'z.B. Das Mädchen wird gefangen',
    },
    {
      label: 'Passiv + Partikelverb',
      value: 'passiveAndParticleVerb',
      checkboxLabel: 'z.B. Die Frau wird angestarrt',
    },
  ],
  SVO: [
    ...SVO_COMMON_CHECK_BOX,
    {
      label: 'Passiv',
      value: 'passive',
      checkboxLabel: 'z.B. Die Frau wird von dem Mann untersucht',
    },
    {
      label: 'Passiv + Partikelverb',
      value: 'passiveAndParticleVerb',
      checkboxLabel: 'z.B. Die Frau wird von dem Mann angestarrt',
    },
  ],
};

export const BASIC_PRONOMEN_CHECK_BOX: Record<SentenceType, CheckboxType[]> = {
  OV: OV_CHECK_BOX,
  SV: [
    {
      label: 'Standard',
      value: 'standard',
      checkboxLabel: 'z.B. Ich lese',
    },
    {
      label: 'Partikelverb',
      value: 'particleVerb',
      checkboxLabel: 'z.B. Sie schläft ein',
    },
    {
      label: 'Reflexives Verb',
      value: 'reflexiveVerb',
      checkboxLabel: 'z.B. Er kämmt sich',
    },
    {
      label: 'Partikelverb + Reflexives Verb',
      value: 'particleVerbAndReflexiveVerb',
      checkboxLabel: 'z.B. Er schnallt sich an',
    },
    {
      label: 'Passiv',
      value: 'passive',
      checkboxLabel: 'z.B. Sie wird gefangen',
    },
    {
      label: 'Passiv + Partikelverb',
      value: 'passiveAndParticleVerb',
      checkboxLabel: 'z.B. Sie wird angestarrt',
    },
  ],
  SVO: [
    {
      label: 'Standard',
      value: 'standard',
      checkboxLabel: 'z.B. Sie backt Muffins',
    },
    {
      label: '2 Personen',
      value: 'secondPerson',
      checkboxLabel: 'z.B. Er umarmt die Frau',
    },
    {
      label: 'Partikelverb',
      value: 'particleVerb',
      checkboxLabel: 'z.B. Sie hebt Geld ab',
    },
    {
      label: 'Reflexives Verb',
      value: 'reflexiveVerb',
      checkboxLabel: 'z.B. Er kämmt sich die Haare',
    },
    {
      label: 'Präposition',
      value: 'preposition',
      checkboxLabel: 'z.B. Sie joggen im Park',
    },
    {
      label: 'Objekt mit Artikel',
      value: 'objectWithArticle',
      checkboxLabel: 'z.B. Ich schreibe einen Brief',
    },
    {
      label: 'Partikelverb + 2 Personen',
      value: 'particleVerbAndSecondPerson',
      checkboxLabel: 'z.B. Er liest dem Jungen vor',
    },
    {
      label: 'Partikelverb + Reflexives Verb',
      value: 'particleVerbAndReflexiveVerb',
      checkboxLabel: 'z.B. Er schneidet sich die Haare ab',
    },
    {
      label: 'Passiv',
      value: 'passive',
      checkboxLabel: 'z.B. Sie wird von dem Mann untersucht',
    },
    {
      label: 'Passiv + Partikelverb',
      value: 'passiveAndParticleVerb',
      checkboxLabel: 'z.B. Sie wird von dem Mann angestarrt',
    },
  ],
};

export const BASIC_CHECK_BOX: Record<SentenceType, CheckboxType[]> = {
  OV: OV_CHECK_BOX,
  SV: SV_COMMON_CHECK_BOX,
  SVO: SVO_COMMON_CHECK_BOX,
  VO: VO_CHECK_BOX,
};
